import template from './sw-cms-preview-text-teaser-section.html.twig';
import './sw-cms-preview-text-teaser-section.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
